import React from 'react';

import { Body, Modal } from '@icarros/ids-react';

interface MultipleEditsModalProps {
  modalOpen: boolean;
  setModalOpen(value: boolean): void;
  title: string;
  body: string;
  handleContinue: () => void;
  handleBack: () => void;
  secondaryButtonText?: string;
}

export function MultipleEdits({
  modalOpen,
  setModalOpen,
  title,
  body,
  handleContinue,
  handleBack,
  secondaryButtonText = 'voltar'
}: MultipleEditsModalProps): JSX.Element {
  return (
    <Modal
      stateOpen={[modalOpen, setModalOpen]}
      body={
        <Body size="body_2" contrast="default" weight="regular" variant="base">
          {body}
        </Body>
      }
      title={title}
      mainButtonText="continuar"
      mainButtonMethod={() => {
        setModalOpen(false);
        handleContinue();
      }}
      secondaryButtonText={secondaryButtonText}
      secondaryButtonMethod={() => {
        setModalOpen(false);
        handleBack();
      }}
    />
  );
}
